var originalSrc = '';
var originalPrice = $('.eyecatcher span').html();

var cgAbTestSuggestNewLayout = false;

(function ($) {
    var Location = function () {
        this.isHistoryItem = false;
        this.isUnknownCity = false;
        this.reference = null;
    };

    Location.prototype = {
        getShowname: function (useGlyph) {
            var name = '';
            var showName = null;
            var matchValue = this.request.getName();
            var replaceValue = this.name;
            var minimalValue = '';
            var reg = new RegExp(matchValue, 'i');

            var highlightSearch = function (input, searchToken) {
                var searchRegex = reg;
                if (typeof searchToken !== 'undefined') {
                    searchRegex = new RegExp('^' + searchToken, 'i');
                }

                var found = input.match(searchRegex);
                if (found) {
                    var reg2 = new RegExp(found[0], 'i');
                    input = input.replace(reg2, '<i>' + found[0] + '</i>');
                }

                return input;
            };

            var isStateName = function (state_name, distance) {
                // bad Fix for wrong 'Festland' states
                if (state_name) {
                    if (typeof distance === 'undefined') {
                        return true;
                    }
                    return (
                        state_name.indexOf('Festland') === -1 &&
                        state_name.indexOf('continent') === -1
                    );
                }
                return false;
            };

            replaceValue = highlightSearch(replaceValue);

            var airportIcon =
                '<i class="flt-lft icn-airplane pdg-top-3 pdg-rgt-4 airport"></i>';
            var cityIcon =
                '<i style="font-size: 13px; border: 0" class="flt-lft icon-city pdg-top-3 pdg-rgt-4 mgn-r-7"></i>';
            var railIcon =
                '<i style="font-size: 13px; border: 0" class="flt-lft icon-train pdg-top-3 pdg-rgt-4 mgn-r-7"></i>';
            var countryIcon =
                '<i class="country icn-arrow-right flt-rgt pdg-top-4"></i>';
            var stateIcon =
                '<i class="state icn-arrow-right flt-rgt pdg-top-4"></i>';

            if (ApplicationProperties.get('isInlineSvgActive')) {
                airportIcon =
                    '<svg class="isvg-suggest flt-lft pdg-top-3 pdg-rgt-4 mgn-r-7"><use xlink:href="#s-plane" /></svg>';
            }

            if (ApplicationProperties.get('isInlineSvgActive')) {
                cityIcon =
                    '<svg class="isvg-suggest flt-lft pdg-top-3 pdg-rgt-4 mgn-r-7"><use xlink:href="#s-city" /></svg>';
            }

            if (ApplicationProperties.get('isInlineSvgActive')) {
                railIcon =
                    '<svg class="isvg-suggest flt-lft pdg-top-3 pdg-rgt-4 mgn-r-7"><use xlink:href="#s-rail" /></svg>';
            }

            if (cgAbTestSuggestNewLayout) {
                railIcon = '<i class="flt-lft icon-train fns-18"></i>';
                airportIcon = '<i class="flt-lft icon-plane"></i>';
                cityIcon = '<i class="flt-lft icon-city fns-16"></i>';
            }

            if (useGlyph === 1) {
                airportIcon = '<i class="airport glyph">b</i>';
                countryIcon = '<i class="country glyph">r</i>';
                stateIcon = '<i class="state glyph">r</i>';
            }

            if (this.minimal_price) {
                minimalValue =
                    '<span class="mini-price">' +
                    js_tr.suggest.ex +
                    ' ' +
                    this.minimal_price +
                    ' &euro;';

                if (!cgAbTestSuggestNewLayout) {
                    minimalValue += ' ' + js_tr.suggest.day;
                }
                minimalValue += '</span>';
            }

            var delimiter = '';
            if (cgAbTestSuggestNewLayout) {
                delimiter = '<span class="delimiter"></span>';
            }

            switch (this.type) {
                case 'airport':
                    if ('airports' in this && this.airports.length === 1) {
                        replaceValue += ' (' + this.airports[0].code + ')';
                        if (this.airports[0].name) {
                            replaceValue += ', ' + this.airports[0].name;
                        }
                    }

                    name =
                        delimiter +
                        airportIcon +
                        '<span class="wrapper">' +
                        replaceValue;
                    if (!cgAbTestSuggestNewLayout) {
                        name += ', ' + this.country_name;
                    }
                    name += '</span>' + minimalValue;
                    break;

                case 'country':
                    name =
                        '<span>' +
                        replaceValue +
                        ' ' +
                        minimalValue +
                        '</span> ' +
                        countryIcon +
                        ' <b class="flt-rgt clr-grn txt-nrl">(' +
                        js_tr.suggest.country +
                        ')</b>';
                    break;

                case 'state':
                    if (this.isChildSelect) {
                        name =
                            replaceValue +
                            ', <i>' +
                            this.country_name +
                            '</i> ' +
                            minimalValue;
                    } else {
                        name =
                            '<span>' +
                            replaceValue +
                            ', ' +
                            this.country_name +
                            ' ' +
                            minimalValue +
                            '</span> ' +
                            stateIcon +
                            ' <b class="flt-rgt clr-grn txt-nrl">(' +
                            js_tr.suggest.region +
                            ')</b>';
                    }
                    break;

                case 'top_airports':
                    showName =
                        js_tr.suggest.airport +
                        ' &ndash; ' +
                        replaceValue +
                        ' (' +
                        this.code +
                        ')';

                    showName = highlightSearch(showName);

                    name =
                        airportIcon +
                        '<span class="wrapper">' +
                        showName +
                        '</span>' +
                        minimalValue;
                    break;

                case 'airport_search':
                    showName =
                        replaceValue +
                        ' (' +
                        this.code +
                        ') &ndash; ' +
                        js_tr.suggest.airport;

                    showName = highlightSearch(showName, this.searchToken);

                    name =
                        airportIcon +
                        '<span class="wrapper">' +
                        showName +
                        '</span>' +
                        minimalValue;
                    break;

                default:
                    if (this.isChildSelect) {
                        if (this.state_name) {
                            name =
                                replaceValue +
                                ' - <i>' +
                                this.state_name +
                                '</i>, ' +
                                this.country_name +
                                ' ' +
                                minimalValue;
                        } else {
                            name =
                                replaceValue +
                                ', <i>' +
                                this.country_name +
                                '</i> ' +
                                minimalValue;
                        }
                    } else {
                        var regionName = this.country_name;
                        if (isStateName(this.state_name, this.distance)) {
                            regionName =
                                this.state_name + ', ' + this.country_name;
                        }

                        if (!cgAbTestSuggestNewLayout) {
                            var found = regionName.match(reg);
                            if (found) {
                                var reg2 = new RegExp(found[0], 'i');
                                regionName = regionName.replace(
                                    reg2,
                                    '<i>' + found[0] + '</i>'
                                );
                            }
                        }

                        if (this.distance) {
                            name =
                                '<i>(' +
                                Number(this.distance).toFixed() +
                                ' km) ' +
                                replaceValue +
                                '</i>, ' +
                                regionName +
                                ' ' +
                                minimalValue;
                        } else {
                            if (cgAbTestSuggestNewLayout) {
                                regionName =
                                    '<span class="suggest-entry-sub-title">' +
                                    regionName +
                                    '</span>';
                            } else {
                                regionName = ', ' + regionName;
                            }

                            name = replaceValue;
                            if (typeof this.subtype === 'undefined') {
                                name += regionName;
                            }
                            name += ' ' + minimalValue;
                        }
                    }

                    if (
                        typeof this.subtype !== 'undefined' &&
                        this.subtype === 'rail_district'
                    ) {
                        name = delimiter + cityIcon + name;
                    } else if (
                        typeof this.subtype !== 'undefined' &&
                        this.subtype === 'rail'
                    ) {
                        name = delimiter + railIcon + name;
                    } else if (
                        typeof this.subtype !== 'undefined' &&
                        (this.subtype === 'city' || this.subtype === 'district')
                    ) {
                        name = delimiter + cityIcon + name;
                    }
                    break;
            }

            return name;
        },

        getRequestParams: function ($input) {
            var params = {};

            if (this.isUnknownCity) {
                params = {
                    call: 'byLatLng',
                    lat: this.geo.lat,
                    lng: this.geo.lng,
                    cityName: this.name,
                };
            } else {
                params = {
                    call: 'byParentLocation',
                    code: this.code,
                    type: this.type,
                    version: 'truck' === $('#vehicleType').val() ? 'truck' : '',
                    location: $input.attr('id'),
                };
            }

            return Object.assign(LocationHelper.getCoreRequestParams(), params);
        },

        getClassName: function () {
            var className = this.type;

            if (typeof this.subtype !== 'undefined') {
                className += ' ' + this.subtype;
            } else if (className === 'city') {
                className += ' city_group';
            }

            if ('className' in this) {
                className += ' ' + this.className;
            }

            return className;
        },

        getCacheKey: function ($input) {
            var result = '';
            var params = this.getRequestParams($input);
            for (var key in params) {
                result += key + params[key];
            }

            return result;
        },

        canBeRequested: function () {
            var searchable = ['country', 'state'];

            return $.inArray(this.type, searchable) > -1;
        },

        getBacklinkText: function () {
            return js_tr.suggest.back_to + ' ' + this.name;
        },

        getName: function () {
            return this.name;
        },

        getImagePath: function () {
            return this.image_path === '' ? null : this.image_path;
        },

        getMinimalPrice: function () {
            return this.minimal_price;
        },

        groupItems: function (items) {
            if (items.length === 0) {
                return items;
            }

            var topResult = [];
            var result = items;

            if (result[0].top === '1') {
                topResult.push(js_tr.suggest.top_cities);
                var resultLength = result.length;
                while (resultLength > 0 && result[0].top === '1') {
                    topResult.push(result.shift());
                }
            }

            var noState = false;

            if (result.length > 100) {
                result = this.groupAlphabetic(result);
            } else {
                noState = true;
            }

            var selectType = result[0].type;
            if (selectType === 'state') {
                result.unshift(js_tr.suggest.choose_state);
            } else if (
                (this.type === 'state' && noState === false) ||
                noState === true
            ) {
                result.unshift(js_tr.suggest.cities_in + ' ' + this.name);
            }

            return topResult.concat(result);
        },

        groupAlphabetic: function (items) {
            var activeLetter = null,
                firstLetter,
                result = [];
            var itemsLength = items.length;
            for (var i = 0; i < itemsLength; i++) {
                firstLetter = items[i].name.charAt(0);
                if (firstLetter !== activeLetter) {
                    activeLetter = firstLetter;
                    result.push(activeLetter);
                }
                result.push(items[i]);
            }

            return result;
        },

        isLocation: function () {
            return true;
        },
    };

    var SynonymRequest = function (term, parentLocation) {
        this.term = $.trim(term);
        this.type = 'synonym';

        this.parentLocation = parentLocation;

        this.isHistoryItem = false;
        this.isUnknownCity = false;
        this.reference = null;
    };

    SynonymRequest.prototype = {
        getRequestParams: function ($input) {
            var params = {};

            if (this.parentLocation) {
                params = {
                    call: 'bySynonymWithParent',
                    synonym: this.term,
                    type: this.parentLocation.type,
                    code: this.parentLocation.code,
                };

                return Object.assign(
                    LocationHelper.getCoreRequestParams(),
                    params
                );
            }
            params = {
                call: 'bySynonym',
                synonym: this.term,
                version: 'truck' === $('#vehicleType').val() ? 'truck' : '',
                location: $input.attr('id'),
            };

            return Object.assign(LocationHelper.getCoreRequestParams(), params);
        },

        isLocation: function () {
            return false;
        },

        getCacheKey: function ($input) {
            var result = '';
            var params = this.getRequestParams($input);
            for (var key in params) {
                result += key + params[key];
            }

            return result;
        },

        canBeRequested: function () {
            return true;
        },

        getBacklinkText: function () {
            return js_tr.suggest.back_to_results;
        },

        getName: function () {
            return this.term;
        },

        getImagePath: function () {
            return null;
        },

        getMinimalPrice: function () {
            return null;
        },

        groupItems: function (items) {
            if (items.length === 0) {
                return items;
            }

            var cities = [];
            var countries = [];
            var result = items;
            var resultLength = result.length;

            for (var i = 0; i < resultLength; i++) {
                if (
                    jQuery.inArray(result[i].type, [
                        'city',
                        'airport',
                        'top_airports',
                        'airport_search',
                    ]) > -1
                ) {
                    cities.push(result[i]);
                } else {
                    countries.push(result[i]);
                }
            }

            if (cgAbTestSuggestNewLayout) {
                cities = this.groupBySubTypes(cities);
            }

            if (countries.length > 0 && cities.length > 0) {
                var translationKey = js_tr.suggest.country_and_region;
                if (cgAbTestSuggestNewLayout) {
                    translationKey =
                        js_tr.suggest.country_and_region_upper_case;
                }
                cities.push({
                    className: 'group',
                    content: translationKey,
                });
            }

            return cities.concat(countries);
        },

        groupBySubTypes: function (items) {
            var result = [];
            var groupKey;
            var groups = {};
            var group;
            var type;

            var typeTranslations = {
                airport: js_tr.suggest.airport_label,
                rail: js_tr.suggest.rail_label,
                city: js_tr.suggest.city_label,
                rail_district: js_tr.suggest.rail_district_label,
            };

            for (var i = 0; i < items.length; i++) {
                var item = items[i];

                type = '';
                if (typeof item.subtype !== 'undefined') {
                    type = item.subtype;
                } else if (item.type === 'airport') {
                    type = 'airport';
                }

                groupKey = type + item.code;

                if (!(item.code in groups)) {
                    groups[item.code] = {};
                }

                if (!(type in groups[item.code])) {
                    groups[item.code][type] = [];
                }

                groups[item.code][type].push(item);
            }

            for (var code in groups) {
                var showLabels = false;
                for (groupKey in groups[code]) {
                    if (groups[code][groupKey].length > 1) {
                        showLabels = true;
                        break;
                    }
                }

                for (type in groups[code]) {
                    group = groups[code][type];

                    if (showLabels && type in typeTranslations) {
                        result.push({
                            className: 'group subgroup',
                            content: typeTranslations[type],
                        });

                        group[group.length - 1].className = 'last-group-item';
                    } else if (type !== '') {
                        group[group.length - 1].className = 'single-group-item';
                    }

                    result = result.concat(group);
                }
            }

            return result;
        },
    };

    var LocationHelper = {
        /**
         * return request params used in all calls
         *
         * @returns {{}}
         */
        getCoreRequestParams: function () {
            var pageType = $('#pageType').val();
            var affiliateName = $('#affiliateName').val();
            var landingType = $('#landingType').val();
            var landingId = $('#landingId').val();
            var search = $('#search').val();
            var initialInput = $('#initialInput').val();
            var params = {};

            // fix for strange behaviour if params are send empty
            if (this.isParamNotEmpty(pageType)) {
                params.origin = pageType;
            }

            if (this.isParamNotEmpty(affiliateName)) {
                params.affiliate = affiliateName;
            }

            if (this.isParamNotEmpty(landingType)) {
                params.landingType = landingType;
            }

            if (this.isParamNotEmpty(landingId)) {
                params.landingId = landingId;
            }

            if (this.isParamNotEmpty(search)) {
                params.search = search;
            }

            if (this.isParamNotEmpty(initialInput)) {
                params.initialInput = initialInput;
            }

            return params;
        },

        /**
         * check if param is not empty
         *
         * @param {string} param
         *
         * @returns {boolean}
         */
        isParamNotEmpty: function (param) {
            return param !== '' && param !== null;
        },
    };

    $.fn.extend({
        suggest: function () {
            var $input = $(this);
            var itemHistory = null;
            var requestHistory = [];
            var keepSuggestOpen = false;
            var submitAllowed =
                $('#countryOrState').val() === '1' ? false : true;

            var settings = Object.assign(
                {
                    codeField: $(),
                    container: $(),
                    width: 330,
                    maxHeight: 430,
                    addTop: 0,
                    subWidth: 28,
                    useErrorClass: 0,
                    useSlider: 0,
                    selectInfoInside: 0,
                    positions: ApplicationProperties.get('isMoodIndexActive')
                        ? '-1 8'
                        : '0 0',
                    useGlyph: 0,
                    appLook: false,
                    canvas: null,
                },
                arguments[0] || {}
            );

            var cache = {};

            var cacheGoogleService = {};

            var setSubmitCheck = function () {
                var selectInfo = $('.select-info');

                if (settings.selectInfoInside === 1) {
                    selectInfo.hide();
                }

                if (settings.codeField.attr('id') === 'depAirport') {
                    settings.container
                        .closest('form')
                        .off('submit')
                        .on('submit', function (event) {
                            var selectInfo = $('.select-info');
                            var dep = $('#dep');
                            var depVal = dep.val();
                            var depAirport = $('#depAirport');

                            if (depVal.toLowerCase() === 'london') {
                                depAirport.val('LON');
                                return;
                            }
                            if (depVal.toLowerCase() === 'berlin') {
                                depAirport.val('BER');
                                return;
                            }
                            if (depVal.toLowerCase() === 'sydney') {
                                depAirport.val('SYD');
                                return;
                            }

                            if (
                                (settings.codeField.val() === '' &&
                                    depVal.length !== 3 &&
                                    !$('#depInput').hasClass('error') &&
                                    submitAllowed !== true) ||
                                depVal === 'USA'
                            ) {
                                event.preventDefault();

                                if (settings.selectInfoInside === 1) {
                                    selectInfo.show();
                                    if (
                                        typeof settings.sf.button !==
                                        'undefined'
                                    ) {
                                        settings.sf.button.stop();
                                    }
                                    setTimeout(function () {
                                        $input.autocomplete('widget').show();
                                        setArrowPosition();
                                    }, 100);
                                } else {
                                    if (
                                        mobile !== true ||
                                        $('#isTablet').val() === '1'
                                    ) {
                                        showErrorHint(
                                            '#' +
                                                settings.container
                                                    .find('input')
                                                    .attr('id'),
                                            '#suggest-hint-' + $input.attr('id')
                                        );
                                        $('#find')
                                            .attr('disabled', null)
                                            .prop('disabled', null);
                                    }
                                    var leftArrow = $.Event('keydown');
                                    leftArrow.which = 39;
                                    dep.trigger('focus').trigger(leftArrow);
                                    setTimeout(function () {
                                        $input.autocomplete('widget').show();
                                    }, 100);
                                }
                            }
                        });
                }
            };

            setSubmitCheck();

            var loadLocations = function (request, response) {
                if (!/\w/.test(request.term)) {
                    return;
                }

                var key = request.getCacheKey($input);

                this._setSearchState();

                if (key in cache) {
                    $input.data('autocomplete').geoloc = false;
                    handleResponse(request, response, cache[key]);
                    return;
                }

                if (typeof places !== 'undefined') {
                    places.loadApi();
                }

                /* eslint-disable-next-line jquery/no-ajax */
                $.getJSON(
                    '/suggest_json.php',
                    request.getRequestParams($input),
                    function (data) {
                        var results = [];

                        if (data && data.suggest && data.suggest.results) {
                            var suggestResultLength =
                                data.suggest.results.length;
                            for (var i = 0; i < suggestResultLength; i++) {
                                var location = Object.assign(
                                    new Location(),
                                    data.suggest.results[i]
                                );
                                location.request = request;
                                results.push(location);
                            }

                            cache[key] = results;
                            handleResponse(request, response, results);
                        }
                    }
                );
            };

            var isChildSelect = function () {
                if (
                    requestHistory[requestHistory.length - 1].parentLocation !==
                    null
                ) {
                    return requestHistory.length > 1;
                }
                return false;
            };

            var activeRequest = function () {
                return requestHistory[requestHistory.length - 1];
            };

            var deleteChangedHistoryItems = function (term) {
                var changedIndex = requestHistory.length;
                term = $.trim(term.replace(/,/g, ' ').toLowerCase());

                var requestHistoryLength = requestHistory.length;
                for (var i = 0; i < requestHistoryLength; i++) {
                    var item = requestHistory[i];

                    if (item.isLocation()) {
                        var checkItemName = item.getName().toLowerCase();

                        if (term.indexOf(checkItemName) === 0) {
                            if (item.canBeRequested()) {
                                term = $.trim(
                                    term.substring(checkItemName.length)
                                );
                            }
                        } else {
                            changedIndex = i;
                            break;
                        }
                    }
                }

                requestHistory = requestHistory.slice(0, changedIndex);
                return term;
            };

            var getLocationsFromRequestHistory = function () {
                var result = [];

                var requestHistoryLength = requestHistory.length;
                for (var i = 0; i < requestHistoryLength; i++) {
                    var item = requestHistory[i];

                    if (item.isLocation()) {
                        result.push(item);
                    }
                }

                return result;
            };

            var showErrorHint = function (el, hint) {
                var pos = $(el).offset();
                var mWidth = $(hint).outerWidth();
                var left = pos.left - mWidth - 5 + 'px';
                var top = pos.top - 4 + 'px';
                $(hint).css({
                    left: left,
                    top: top,
                });

                $(hint).show();
            };

            var checkForWrongInput = function () {
                var inputs = $('.ui-autocomplete-input');
                var wrongInput = false;

                inputs.each(function () {
                    if ($(this).parent().hasClass('error')) {
                        wrongInput = true;
                    }
                });

                if (wrongInput) {
                    settings.container.closest('form').bind({
                        submit: function (event) {
                            if (
                                settings.container.find('input').val()
                                    .length !== 3 &&
                                submitAllowed !== true
                            ) {
                                event.preventDefault();
                                if (settings.container.hasClass('error')) {
                                    settings.container
                                        .find('.field-error')
                                        .not(
                                            '#suggest-error-' +
                                                $input.attr('id')
                                        )
                                        .hide();
                                    $(
                                        '#suggest-error-' + $input.attr('id')
                                    ).show();
                                }
                            }
                        },
                    });
                } else {
                    if ($('#depAirport').val() !== '') {
                        settings.container.closest('form').off('submit');
                    }
                }
            };

            var selectItem = function (item, setFocus) {
                $input
                    .data('autocomplete')
                    ._trigger('select', window.event, { item: item });
                $input.data('autocomplete').close(window.event);
                if (setFocus) {
                    $input.trigger('focus');
                }
                if (lastSearchHistory) {
                    lastSearchHistory.resetLastRequest();
                }
            };

            var handleResponse = function (request, response, results) {
                if (0 !== results.length) {
                    if (settings.useErrorClass !== 0) {
                        settings.sf.errors.hide($input.attr('id'));
                    } else {
                        removeMobileErrorClass(settings.container);
                        settings.container.removeClass('error');
                        $('#suggest-error-' + $input.attr('id')).hide();
                    }

                    checkForWrongInput();

                    var isComplete =
                        2 === results.length &&
                        request.term !== undefined &&
                        results[1].name.toLowerCase() ===
                            request.term.toLowerCase();

                    if (
                        1 === results.length &&
                        typeof request.term !== 'undefined' &&
                        results[0].name.toLowerCase() ===
                            request.term.toLowerCase()
                    ) {
                        results[0].isHistoryItem = false;
                        if (
                            (results[0].type !== 'city' &&
                                results[0].type !== 'airport') ||
                            $input.data('autocomplete').geoloc === true
                        ) {
                            results[0].isShowDirect = true;
                            selectItem(results[0], false);
                            submitAllowed = false;
                            $input.data('autocomplete').geoloc = false;
                            return;
                        }
                        submitAllowed = true;
                    } else if (
                        1 === results.length &&
                        typeof request.term === 'undefined' &&
                        results[0].distance < 1
                    ) {
                        keepSuggestOpen = false;
                        settings.codeField.val(results[0].code);
                        var params = results[0].getRequestParams($input);
                        setBackgroundImage(
                            params.origin,
                            results[0].getImagePath(),
                            results[0].getMinimalPrice()
                        );
                        submitAllowed = true;
                        $input.trigger('focus');
                        if (settings.appLook) {
                            $input.data('autocomplete').value = $input.val();
                            settings.canvas.toggle();
                        }
                        return;
                    } else if (isComplete && results[0].type === 'airport') {
                        submitAllowed = true;
                    } else if (isComplete) {
                        submitAllowed = false;

                        var airportCode = getAirportCode(results[0].code);

                        $.each(results, function () {
                            if (
                                getAirportCode(results[0].code) !== airportCode
                            ) {
                                submitAllowed = false;
                            }
                        });
                    } else {
                        if (
                            request.term === undefined &&
                            request.isUnknownCity === true
                        ) {
                            $('#suggest-hint-unknown-city').show();
                        }

                        submitAllowed = false;
                    }
                } else {
                    if (settings.useErrorClass !== 0) {
                        addMobileErrorClass(settings.container);
                        settings.container.addClass('error');
                        settings.container
                            .find('.field-error')
                            .not('#suggest-error-' + $input.attr('id'))
                            .hide();
                    } else {
                        if (
                            typeof places !== 'undefined' &&
                            places.isLoaded === true &&
                            request.term !== undefined
                        ) {
                            getAutocompleteGooglePlaces(request.term);
                        } else {
                            addMobileErrorClass(settings.container);
                            settings.container.addClass('error');
                            settings.container
                                .find('.field-error')
                                .not('#suggest-error-' + $input.attr('id'))
                                .hide();
                            $('#suggest-error-' + $input.attr('id')).show();
                            $('#suggest-hint-unknown-city').hide();

                            var track = new actionTracking({
                                acTrAc: 'unknownCity_nothingFound',
                                acTrLa: $input.val(),
                            });
                            track.push();
                        }
                    }

                    settings.codeField.val('');
                    checkForWrongInput();
                }

                response(results);
            };

            var getAutocompleteGooglePlaces = function (term) {
                if (term in cacheGoogleService) {
                    getAutocompleteGooglePlacesCallback(
                        null,
                        null,
                        cacheGoogleService[term]
                    );
                    return;
                }

                if (places.isLoaded === true) {
                    var service = new google.maps.places.AutocompleteService();

                    service.getPlacePredictions(
                        {
                            input: term,
                        },
                        getAutocompleteGooglePlacesCallback
                    );
                }
            };

            var getAutocompleteGooglePlacesCallback = function (
                predictions,
                status,
                cachedResults
            ) {
                var results = [];

                if (!cachedResults && places.isLoaded === true) {
                    var trackSuggestGoogleAddress = new actionTracking({
                        acTrAc: 'suggest_GoogleAddress',
                        acTrLa: 'isCalled',
                    });
                    trackSuggestGoogleAddress.push();

                    if (status !== google.maps.places.PlacesServiceStatus.OK) {
                        addMobileErrorClass(settings.container);
                        settings.container.addClass('error');
                        $('#suggest-error-' + $input.attr('id')).show();

                        var track = new actionTracking({
                            acTrAc: 'unknownCity_nothingFound',
                            acTrLa: $input.val(),
                        });
                        track.push();

                        return;
                    }
                    removeMobileErrorClass(settings.container);
                    settings.container.removeClass('error');
                    settings.container.find('.field-error').hide();

                    var predictionsLength = predictions.length;

                    for (var i = 0; i < predictionsLength; i++) {
                        var prediction = predictions[i];

                        var predict = {
                            search_name: '',
                            code: '',
                            type: 'city',
                            cityranking: '0',
                            top: '0',
                            name: prediction.terms[0].value,
                            country_name:
                                typeof prediction.terms[2] !== 'undefined'
                                    ? prediction.terms[2].value
                                    : typeof prediction.terms[1] !== 'undefined'
                                    ? prediction.terms[1].value
                                    : '',
                            state_name:
                                typeof prediction.terms[2] !== 'undefined' &&
                                typeof prediction.terms[1] !== 'undefined'
                                    ? prediction.terms[1].value
                                    : '',
                            isPostalSearch: '0',
                            image_path: '',
                        };

                        var synLocation = Object.assign(
                            new Location(),
                            predict
                        );
                        var ucRequest = new SynonymRequest($input.val(), false);
                        ucRequest.isUnknownCity = true;
                        ucRequest.reference = prediction.reference;
                        synLocation.request = ucRequest;
                        synLocation.isUnknownCity = true;
                        synLocation.reference = prediction.reference;
                        results.push(synLocation);
                    }

                    if (results.length === 0) {
                        addMobileErrorClass(settings.container);
                        settings.container.addClass('error');
                        settings.container
                            .find('.field-error')
                            .not('#suggest-error-' + $input.attr('id'))
                            .hide();
                        $('#suggest-error-' + $input.attr('id')).show();
                    } else {
                        cacheGoogleService[$input.val()] = results;
                    }
                } else {
                    removeMobileErrorClass(settings.container);
                    settings.container.removeClass('error');
                    settings.container.find('.field-error').hide();
                    results = cachedResults;
                }
                settings.codeField.val('');
                checkForWrongInput();

                var autocomplete = $input.data('autocomplete');
                var response = autocomplete._response();

                response(results);

                $input
                    .autocomplete('widget')
                    .append(
                        '<li class="pwrd-google"><i class="spr-pwrd-google flt-rgt mgn-5"></i></li>'
                    );
            };

            var getLatLngFromGoogle = function (item) {
                itemHistory = item;
                var placesService = false;

                if (places.isLoaded) {
                    placesService = new google.maps.places.PlacesService(
                        $('<div />')[0]
                    );
                    placesService.getDetails(
                        { reference: item.reference },
                        getLatLngFromGoogleCallback
                    );
                }
            };

            var getLatLngFromGoogleCallback = function (details) {
                if (details) {
                    itemHistory.geo = {
                        lat: details.geometry.location.lat(),
                        lng: details.geometry.location.lng(),
                    };

                    var pos = $input.offset();
                    var hint = $('#suggest-hint-unknown-city');
                    var mWidth = hint.outerWidth();
                    var left = pos.left - mWidth - 5 + 'px';
                    var top = pos.top - 4 + 'px';
                    hint.css({
                        left: left,
                        top: top,
                    });
                    keepSuggestOpen = true;
                    settings.codeField.val('');
                    $('#depCountry').val('');
                    $('#destCountry').val('');
                    setSubmitCheck();
                    var autocomplete = $input.data('autocomplete');
                    loadLocations.call(
                        autocomplete,
                        itemHistory,
                        autocomplete._response()
                    );

                    var track = new actionTracking({
                        acTrAc: 'unknownCity_googleSearch',
                        acTrLa: itemHistory.request.term + '_' + $input.val(),
                    });
                    track.push();
                }
            };

            var getAirportCode = function (code) {
                if (0 < code.indexOf(' ')) {
                    code = code.substr(0, code.indexOf(' ') - 1);
                }

                return code;
            };

            var copyItemFieldToFormField = function (item, name) {
                $('#' + name + '[type="hidden"]').remove();

                if (typeof item[name] !== 'undefined') {
                    $('<input>')
                        .attr({
                            type: 'hidden',
                            id: name,
                            name: name,
                            value: item[name],
                        })
                        .appendTo(settings.container.closest('form'));
                }
            };

            $input.autocomplete({
                minLength: 1,
                appendTo: settings.appLook ? '.suggest-container' : 'body',
                delay:
                    $('#isTablet').val() === '1' || mobile === true ? 100 : 0,
                position: {
                    offset: settings.positions,
                },

                source: function (request, response) {
                    $('#suggest-hint-unknown-city').hide();

                    var nexTerm = deleteChangedHistoryItems(request.term);
                    var synonymRequest;

                    if (
                        requestHistory.length > 0 &&
                        (!requestHistory[
                            requestHistory.length - 1
                        ].isLocation() ||
                            !requestHistory[
                                requestHistory.length - 1
                            ].canBeRequested())
                    ) {
                        requestHistory.pop();
                    }

                    if (requestHistory.length === 0) {
                        synonymRequest = new SynonymRequest(nexTerm);
                    } else {
                        if (nexTerm.length > 0) {
                            var parentLocation =
                                activeRequest().isLocation() &&
                                activeRequest().canBeRequested()
                                    ? activeRequest()
                                    : null;
                            synonymRequest = new SynonymRequest(
                                nexTerm,
                                parentLocation
                            );
                        } else {
                            synonymRequest = activeRequest();
                        }
                    }

                    if (false === synonymRequest.isHistoryItem) {
                        synonymRequest.isHistoryItem = true;
                        requestHistory.push(synonymRequest);
                    }

                    if (synonymRequest.canBeRequested()) {
                        loadLocations.call(
                            $input.data('autocomplete'),
                            synonymRequest,
                            response
                        );
                    }
                },

                open: function () {
                    if (settings.appLook) {
                        $('.storage').hide();
                    }
                    $('#depCountry').val('');
                    setSubmitCheck();

                    var width = settings.width;

                    $input.autocomplete('widget').css({
                        width: width,
                    });

                    setArrowPosition();
                    setLinkBackPosition();
                },

                select: function (event, ui) {
                    var autocomplete = $(this).data('autocomplete');

                    $('#suggest-hint-unknown-city').hide();

                    if (ui.item.isUnknownCity === true) {
                        getLatLngFromGoogle(ui.item);
                        return;
                    }

                    var params = ui.item.getRequestParams($input);

                    // search does not support dest to be certain airport
                    if ('dep' === $input.attr('id')) {
                        copyItemFieldToFormField(ui.item, 'airport_pickup');
                        copyItemFieldToFormField(ui.item, 'rail_station');
                    }

                    if (
                        false === ui.item.isHistoryItem &&
                        ui.item.isUnknownCity === false
                    ) {
                        ui.item.isHistoryItem = true;
                        requestHistory.push(ui.item);
                    }

                    var terms = $.map(
                        getLocationsFromRequestHistory(),
                        function (location) {
                            return location.getName();
                        }
                    );

                    if (
                        requestHistory.length > 0 &&
                        !requestHistory[requestHistory.length - 1].isLocation()
                    ) {
                        terms.push(
                            requestHistory[requestHistory.length - 1].getName()
                        );
                    }

                    var name = terms.join(', ');

                    if (ui.item.canBeRequested() && ui.item.isLocation()) {
                        name = name.replace(/[,\s]$/, '') + ', ';
                    }

                    var inputHis = $input.val();

                    $input.val(name);
                    $input.data('autocomplete').term = name;
                    $input.data('autocomplete').value = name;

                    setBackgroundImage(
                        params.origin,
                        ui.item.getImagePath(),
                        ui.item.getMinimalPrice()
                    );
                    if (ui.item.canBeRequested()) {
                        keepSuggestOpen = true;
                        settings.codeField.val('');
                        $('#depCountry').val('');
                        $('#destCountry').val('');
                        setSubmitCheck();
                        loadLocations.call(
                            autocomplete,
                            ui.item,
                            autocomplete._response()
                        );
                    } else {
                        keepSuggestOpen = false;
                        settings.codeField.val(ui.item.code);
                        $('#suggest-hint-dep').hide();
                        settings.container.closest('form').off('submit');

                        $input.trigger('select.suggest', [autocomplete, ui]);
                        if (
                            ApplicationProperties.get('isAppMode') ||
                            mobile === true
                        ) {
                            $input.trigger('blur');
                        } else {
                            $input.trigger('focus');
                        }

                        if (ui.item.distance) {
                            var track = new actionTracking({
                                acTrAc: 'unknownCity_nearestCitySelected',
                                acTrLa: inputHis + '_' + $input.val(),
                            });
                            track.push();
                            setShowOnlyCityRailFilter($(this).closest('form'));
                        }
                    }
                    if (settings.appLook) {
                        if (!ui.item.canBeRequested()) {
                            settings.canvas.toggle();
                        }
                    }

                    return false;
                },
            });

            if ($input.data('autocomplete')) {
                $input.data('autocomplete').options.position = Object.assign(
                    $input.data('autocomplete').options.position,
                    {
                        my: $input.hasClass('suggestLeftAligned')
                            ? 'right top'
                            : 'left top',
                        at: $input.hasClass('suggestLeftAligned')
                            ? 'right bottom'
                            : 'left bottom',
                    }
                );

                if (
                    !$input
                        .autocomplete('widget')
                        .parent()
                        .hasClass('auto-suggest')
                ) {
                    var div = $('<div class="auto-suggest" />');

                    div.on('click', function () {
                        keepSuggestOpen = true;
                    });

                    div.on('outerclick', function () {
                        keepSuggestOpen = false;
                    });

                    $input.autocomplete('widget').wrap(div);
                }

                $input.data('autocomplete')._renderItem = function (ul, item) {
                    if (typeof item === 'string') {
                        return $('<li></li>')
                            .addClass('group')
                            .data('item.autocomplete', item)
                            .html(item, '<i></i>')
                            .appendTo(ul);
                    } else if ('content' in item) {
                        return $('<li></li>')
                            .addClass(item.className)
                            .data('item.autocomplete', item)
                            .html(item.content, '<i></i>')
                            .appendTo(ul);
                    }
                    item.value = $(document.createElement('div'))
                        .html(item.name)
                        .text();

                    item.isChildSelect = isChildSelect();

                    var link = $(document.createElement('a'))
                        .html(item.getShowname(settings.useGlyph))
                        .addClass('needsclick');

                    if ('airports' in item && item.airports.length > 1) {
                        var $airportList = $('<ul/>').addClass(
                            'auto-suggest-airport-list'
                        );
                        var airportLength = item.airports.length;

                        for (var i = 0; i < airportLength; i++) {
                            var airport = item.airports[i];
                            var airportName = airport.name
                                ? airport.name
                                : item.name;
                            $('<li/>')
                                .addClass('auto-suggest-airport-entry')
                                .text(
                                    '- ' +
                                        airportName +
                                        ' (' +
                                        airport.code +
                                        ')'
                                )
                                .appendTo($airportList);
                        }

                        $airportList.appendTo(link);
                    }

                    return $('<li></li>')
                        .addClass(item.getClassName())
                        .data('item.autocomplete', item)
                        .append(link)
                        .appendTo(ul);
                };

                $input.data('autocomplete')._renderMenu = function (ul, items) {
                    var unkownCity = false;

                    items = activeRequest().groupItems(items);

                    $.each(
                        items,
                        function (index, item) {
                            if (item.distance) {
                                unkownCity = true;
                            }
                            if ($('#isTablet').val() === '1') {
                                if (
                                    index < 4 ||
                                    (index >= 4 && item.type !== 'city') ||
                                    isChildSelect()
                                ) {
                                    this._renderItemData(ul, item);
                                }
                            } else {
                                this._renderItemData(ul, item);
                            }
                        }.bind(this)
                    );

                    if (settings.selectInfoInside === 1) {
                        $('#selectInfo').template('select-info');
                        ul.prepend($.tmpl('select-info'));
                    }
                    if (
                        requestHistory.length >= 2 &&
                        requestHistory[requestHistory.length - 1]
                            .isShowDirect !== true &&
                        requestHistory[requestHistory.length - 1]
                            .parentLocation !== null
                    ) {
                        var item = requestHistory[requestHistory.length - 2];

                        $(document.createElement('a'))
                            .addClass('link-back bgc-blc')
                            .data('item.autocomplete', item)
                            .html(
                                '<i class="backIcon fsi-12 icn-arrow-left glyph-xs"></i>' +
                                    item.getBacklinkText()
                            )
                            .on('mousedown', function () {
                                keepSuggestOpen = true;
                            })
                            .on('mouseup', function () {
                                keepSuggestOpen = true;
                            })
                            .on('click', function () {
                                clearTimeout(
                                    $input.data('autocomplete').closing
                                );
                                keepSuggestOpen = true;
                                requestHistory.pop();
                                settings.codeField.val('');
                                $('#depCountry').val('');
                                setSubmitCheck();
                                selectItem(item, true);
                            })
                            .dblclick(function () {
                                keepSuggestOpen = true;
                            })
                            .appendTo(ul.parent());
                    } else {
                        ul.parent().find('.link-back').remove();
                    }

                    if (mobile === true && $('#isTablet').val() !== '1') {
                        var headline = $(document.createElement('li'))
                            .addClass('header')
                            .html(js_tr.suggest.please_select);
                        if (unkownCity) {
                            headline = $(document.createElement('li'))
                                .addClass('header')
                                .html(js_tr.suggest['hint-unknown-city']);
                        }

                        ul.prepend(headline);
                    }

                    ul.css('z-index', 9999).scrollTop(0);
                    if (ApplicationProperties.get('suggestHeight')) {
                        ul.css(
                            'max-height',
                            ApplicationProperties.get('suggestHeight')
                        );
                    }
                };

                $input.on('mousedown', function () {
                    $input.autocomplete('search', $input.val());
                });

                $input.data('autocomplete').close = function (ev) {
                    if (false === keepSuggestOpen) {
                        this.cancelSearch = true;
                        if (!settings.appLook) {
                            this._close(ev);
                        }
                        $input
                            .autocomplete('widget')
                            .parent()
                            .find('.arrow')
                            .remove();
                        $input
                            .autocomplete('widget')
                            .parent()
                            .find('.link-back')
                            .remove();
                        if ($input.val() === '') {
                            settings.codeField.val('');
                            removeMobileErrorClass(settings.container);
                            settings.container.removeClass('error');
                            if (settings.appLook) {
                                $('.storage').show();
                            }
                        } else {
                            if ($('#isTablet').val() === '1') {
                                if (!settings.container.hasClass('error')) {
                                    $input.trigger('blur');
                                    if (
                                        $('#isIndex').val() === '1' &&
                                        (false === $('#depDate').is(':focus') ||
                                            'false' ===
                                                $('#depDate').attr('focus'))
                                    ) {
                                        setTimeout(function () {
                                            sf.toggleElement('depDate', 1);
                                            $('#depDate').trigger('focus');
                                        }, 100);
                                    } else {
                                        keepSuggestOpen = true;
                                        return false;
                                    }
                                }
                            }
                        }
                    } else {
                        keepSuggestOpen = false;
                    }
                };
            }

            var setShowOnlyCityRailFilter = function (searchForm) {
                var $showOnlyCityRail = searchForm.find(
                    'input[name=showOnlyCityRail]'
                );
                if (!$showOnlyCityRail.length) {
                    $showOnlyCityRail = $('<input/>', {
                        type: 'checkbox',
                        style: 'display: none',
                        name: 'showOnlyCityRail',
                        value: 'yes',
                    }).appendTo(searchForm);
                }
                $showOnlyCityRail.attr('checked', true).prop('checked', true);
            };

            var setBackgroundImage = function (origin, replacement, price) {
                var isDefaultPath = null;

                if (settings.useSlider === 1) {
                    if (replacement === null || replacement === '') {
                        isDefaultPath = true;
                        $('#stage img').attr(
                            'src',
                            '/static/default/global/graphic/redesign/mood/' +
                                replacement
                        );
                    } else {
                        isDefaultPath = false;
                        $('#stage img').attr(
                            'src',
                            '/static/bm/global/files/images/' + replacement
                        );
                    }

                    var cfg = {
                        image: replacement,
                        price: typeof price !== 'undefined' ? price : null,
                        headline: {
                            type: 1,
                            main: $input.val(),
                            sub: null,
                        },
                        teaser: null,
                        isDefaultPath: isDefaultPath,
                    };
                    stj.slider.show(cfg);
                }

                if (typeof changeDestinationImage === 'undefined') {
                    var eyecatcher = $('.eyecatcher');
                    var eyecatcherGeneric = $('.eyecatcherGeneric');
                    var eyecatcherWithoutTooltip = $(
                        '.eyecatcherWithoutTooltip'
                    );

                    if (origin === 'sem' || origin === 'stage') {
                        var img = $('img.search-form-bg').length
                            ? $('.search-form-bg')
                            : $('#stageDefaultImage');

                        if (img.length === 0) {
                            return false;
                        }

                        eyecatcher.hide();
                        eyecatcherGeneric.hide();
                        eyecatcherWithoutTooltip.hide();

                        if (replacement !== null) {
                            var imageString = img.attr('src');
                            if (originalSrc !== '') {
                                img.attr(
                                    'src',
                                    imageString.replace(
                                        /images\/.*\.jpg/g,
                                        'images/' + replacement
                                    )
                                );
                            } else {
                                originalSrc = imageString;
                                img.attr(
                                    'src',
                                    imageString.replace(
                                        /graphic\/image\/bg_stage.*\.jpg/g,
                                        'files/images/' + replacement
                                    )
                                );
                            }
                        } else {
                            if (originalSrc !== '') {
                                img.attr('src', originalSrc);
                                originalSrc = '';
                            }
                        }
                        eyecatcherGeneric.show();
                    }
                }
            };

            var setLinkBackPosition = function () {
                var linkBack = $input
                    .autocomplete('widget')
                    .parent()
                    .find('.link-back');

                if (linkBack.length) {
                    var height = parseInt(
                        $input.autocomplete('widget').outerHeight() - 2,
                        10
                    );
                    var top = parseInt(
                        $input.autocomplete('widget').css('top'),
                        10
                    );
                    var width = 0;

                    if (mobile !== true) {
                        width = parseInt(
                            $input.autocomplete('widget').outerWidth(true),
                            10
                        );
                        if (isChildSelect() && height > settings.maxHeight) {
                            top =
                                top +
                                settings.addTop +
                                settings.maxHeight +
                                2 +
                                'px';
                        } else {
                            top = top + settings.addTop + height + 'px';
                        }
                    } else {
                        width = parseInt(
                            $input.autocomplete('widget').innerWidth() - 28,
                            10
                        );
                        top = parseInt(top, 10) + parseInt(height, 10) + 'px';
                    }

                    linkBack.css({ width: width });

                    var left = $input.autocomplete('widget').css('left');
                    var zIndex = $input.autocomplete('widget').css('z-index');

                    linkBack.css({
                        top: top,
                        left: left,
                        'z-index': zIndex + 1,
                    });

                    linkBack.show();
                }
            };

            var setArrowPosition = function () {
                var parentSug = $input.autocomplete('widget').parent();

                var top =
                    parseInt($input.autocomplete('widget').css('top'), 10) -
                    4 +
                    'px';
                var left = $input.autocomplete('widget').css('left');

                $('<div class="arrow" />')
                    .css({ top: top, left: left, 'z-index': 10000 })
                    .appendTo(parentSug);
            };

            var setWidgetPosition = function () {
                var position = {
                    of: this.element,
                };

                if (this.options) {
                    position = Object.assign(position, this.options.position);
                }

                if (this.menu) {
                    this.menu.element.position(position);
                    setLinkBackPosition();
                }
            };

            function isMobileInputWrapper(wrapper) {
                return (
                    wrapper.length &&
                    (wrapper.hasClass('dep-holder') ||
                        wrapper.hasClass('optional-location'))
                );
            }

            function addMobileErrorClass(container) {
                if (ApplicationProperties.get('mobile')) {
                    var wrapper = container.parent();
                    if (isMobileInputWrapper(wrapper)) {
                        wrapper.addClass('error');
                    }
                }
            }

            function removeMobileErrorClass(container) {
                if (ApplicationProperties.get('mobile')) {
                    var wrapper = container.parent();
                    if (isMobileInputWrapper(wrapper)) {
                        wrapper.removeClass('error');
                    }
                    var $errorMessage = wrapper.nextAll('p.error');
                    if ($errorMessage.length) {
                        $errorMessage.remove();
                    }
                }
            }

            $(window).on('resize', function () {
                setWidgetPosition.call($input.data('autocomplete'));
            });

            $('#find').on('click', function () {
                keepSuggestOpen = true;
            });

            return this;
        },
    });
})(jQuery);
